import {HttpInterceptorFn} from '@angular/common/http'

/**
 * Interetps HTTP requests to add session information to the headers so that the backend can identify the user.
 */
export const corsInterceptor: HttpInterceptorFn = (req, next) => {

	const clonedReq = req.clone({
		setHeaders: {
			'Access-Control-Allow-Origin': '*'
		}
	})
	return next(clonedReq)
}
